// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "0ae1773c" + "." + "2b9c95893545c4ab" + ".js";
};